import { Modal } from "antd";
import React, { useEffect, useState } from "react";
import HeartRateChart from "../../Pages/GarminCards/HeartRateChart";
import PatientService from "../../../Services/PatientService";
import dayjs from "dayjs";

const HRData = ({ smartWatchId }) => {
  const [chartModal, setChartModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showChart, setShowChart] = useState("");
  const [heartRate, setHeartRate] = useState();
  useEffect(() => {
    if (smartWatchId) {
      fetch1DData();
    }
  }, []);

  const fetch1DData = async (date) => {
    if (!smartWatchId) return;
    const start = dayjs(date).format("DD/MM/YYYY");
    const payload = {
      type: "HR",
      userId: smartWatchId,
      fromDate: start,
      toDate: start,
      limit: 1,
      offset: 0,
    };
    try {
      setLoading(true);
      const res = await PatientService.patientWatchData(payload);
      if (res?.data?.length > 0) {
        setHeartRate(res?.data[0]?.heartRate);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const onChartClose = () => {
    setShowChart("");
    setChartModal(false);
  };

  const handleTypeCharOpen = () => {
    setChartModal(true);
  };
  return (
    <div className="relative flex flex-col">
      {/* Main Card */}
      <div
        title="Click to view Graph"
        className="w-full h-40 bg-white rounded-lg shadow flex flex-col justify-center items-center p-4 cursor-pointer"
        onClick={handleTypeCharOpen}
      >
        <div className="flex items-center gap-2 self-start">
          <h2 className="text-sm font-sans font-semibold">Heart Rate</h2>
        </div>

        {loading ? (
          <div className="flex flex-col items-center justify-center h-full w-full">
            <div className="w-3/4 h-1.5 bg-gray-200 rounded-full overflow-hidden">
              <div className="h-full bg-blue-500 animate-horizontal-pulse"></div>
            </div>
            <p className="mt-3 text-gray-600 text-sm font-medium">Loading...</p>
          </div>
        ) : (
          <div className=" flex flex-col items-center">
            <div className="relative w-20 h-20">
              <svg className="w-full h-full" viewBox="0 0 36 36">
                <path
                  className="stroke-gray-200"
                  strokeWidth="3"
                  fill="none"
                  d="M18 2.0845a15.9155 15.9155 0 1 1 0 31.831 15.9155 15.9155 0 1 1 0-31.831"
                />
                <path
                  className="stroke-[#f97316]"
                  strokeWidth="3"
                  strokeDasharray={`${(25 / 100) * 100}, 100`}
                  strokeLinecap="round"
                  fill="none"
                  d="M18 2.0845a15.9155 15.9155 0 1 1 0 31.831 15.9155 15.9155 0 1 1 0-31.831"
                />
              </svg>
              <span className="absolute inset-0 flex items-center justify-center text-sm font-semibold">
                {Math.round(heartRate || 100)}
              </span>
            </div>
            <p className="text-xs font-medium text-gray-600 mt-1">bpm</p>
          </div>
        )}
      </div>

      <Modal
        open={chartModal}
        onCancel={onChartClose}
        footer={null}
        width={900}
        title={"Heart Rate"}
        destroyOnClose
      >
        <HeartRateChart smartWatchId={smartWatchId} />
      </Modal>
    </div>
  );
};

export default HRData;
